(function(){
    'use-strict';
    if(window.installTheme){
        return;
    }

    const isNativeSupport = window && window.CSS && window.CSS.supports && window.CSS.supports('(--a: 0)');

    const parameterNameIdx = 0;
    const varNameIdx = 1;
    const cssDefStartIdx = 2;
    const cssDefEndIdx = 3;
    const varDefStartIdx = 4;
    const varDefEndIdx = 5;
    function replaceVars(css, map, vars) {
        // element is array:
        //  0 - parameter name
        //  1 - var name
        //  2 - startPosition for css definition
        //  3 - endPosition for css definition
        //  4 - startPosition for var definition
        //  5 - endPosition for var definition
        let additional = 0;
        let varValue, elementLength, additionalInParam;
        map.forEach(function (element){
            element[cssDefStartIdx] += additional;
            element[cssDefEndIdx] += additional;
            element[varDefStartIdx] += additional;
            element[varDefEndIdx] += additional;
            varValue = vars[element[varNameIdx]];
            if(varValue === undefined)
            {
                return
            }
            elementLength = element[cssDefEndIdx] - element[cssDefStartIdx];
            if(varValue === null && elementLength!=0){
                css = css.slice(0, element[cssDefStartIdx]) + css.slice(element[cssDefEndIdx]);
                additional += element[cssDefStartIdx] - element[cssDefEndIdx];
                element[cssDefEndIdx] = element[cssDefStartIdx];
                element[varDefStartIdx] = element[cssDefStartIdx];
                element[varDefEndIdx] = element[cssDefStartIdx];
            }else if(varValue)
            {
                if(elementLength!=0)
                {
                    additionalInParam = varValue.length - (element[varDefEndIdx] - element[varDefStartIdx]);
                    additional += additionalInParam
                    css = css.slice(0, element[varDefStartIdx]) + varValue + css.slice(element[varDefEndIdx])
                    element[varDefEndIdx] += additionalInParam;
                    element[cssDefEndIdx] += additionalInParam
                }else
                {
                    css = css.slice(0, element[varDefStartIdx]) + element[parameterNameIdx] + ':' + varValue + ';' + css.slice(element[varDefStartIdx])
                    element[cssDefEndIdx] = element[cssDefStartIdx] + element[parameterNameIdx].length + varValue.length + 2;
                    element[varDefStartIdx] = element[cssDefStartIdx] + element[parameterNameIdx].length + 1;
                    element[varDefEndIdx] = element[varDefStartIdx] + varValue.length;
                }
            }
        });
        return {css: css, map: map};
    }

    import('../brandingCustomization/index.js').then(({buttonCornerRadiusChanger,
        colorChanger,
        fontChanger,
        panelCornerRadiusChanger}) => {
            window.colorChanger = {update: colorChanger.updateDeprecated.bind(colorChanger)}
            window.panelCornerRadiusChanger = {update: panelCornerRadiusChanger.updateDeprecated.bind(panelCornerRadiusChanger)}
            window.buttonCornerRadiusChanger = {update: buttonCornerRadiusChanger.updateDeprecated.bind(buttonCornerRadiusChanger)}
            window.fontChanger = {update: fontChanger.updateDeprecated.bind(fontChanger)}
    });

    let styleCustomization = {};
    function createStyleCustomization(key)
    {
        styleCustomization[key] = document.createElement('style');
        styleCustomization[key].type = 'text/css';
        let head = document.head || document.getElementsByTagName('head')[0];
        head.appendChild(styleCustomization[key]);
    }



    const themes = {}
    window.installTheme = function(theme){
        let style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(theme.css));
        style.setAttribute('theme', theme.name?theme.name:':root');
        style.varMap = theme.map;
        style.currentVars = style.originVars = theme.vars;
        let head = document.head || document.getElementsByTagName('head')[0];
        head.appendChild(style);
        themes[theme.name?theme.name:':root'] = style;
    }

    window.applyCustomization = function(vars, key = 'main'){
        if(isNativeSupport)
        {
            let str = typeof vars === 'string' ? vars : '';
            Object.keys(vars).forEach( function (name){
                if(Object.keys(vars[name])==0){
                    return;
                }
                str += name + ' {';
                Object.keys(vars[name]).forEach(function(propertyName){
                    str += (isNaN(propertyName) ? propertyName + ':' : '') + vars[name][propertyName] + ';';
                })
                str+='}'
            })
            if(!styleCustomization[key])
            {
                createStyleCustomization(key);
            }
            styleCustomization[key].innerHTML = str;
        } else {
            if(typeof vars === 'string') {
                var styleElement = document.createElement('style');
                styleElement.setAttribute('type', 'text/css');
                var textNode = document.createTextNode(vars);
                styleElement.appendChild(textNode);
                var head = document.getElementsByTagName('head')[0];
                head.appendChild(styleElement);
            } else {
                Object.keys(vars).forEach(function(theme){
                    let style = themes[theme];
                    if(!style)
                    {
                        return;
                    }
                    let themeVars = vars[theme]
                    let checkStyles = Object.keys(style.currentVars).concat(Object.keys(style.originVars)).concat(Object.keys(themeVars));
                    let changes = {};
                    checkStyles.forEach(function(name){
                        if (themeVars[name] && style.currentVars[name] != themeVars[name])
                        {
                            changes[name] = themeVars[name];
                        }else if(!themeVars[name] && style.currentVars[name] != style.originVars[name]){
                            changes[name] = style.originVars[name] || null;
                        }
                    })

                    if(Object.keys(changes) == 0)
                    {
                        return;
                    }

                    let result = replaceVars(style.innerHTML, style.varMap, changes);
                    style.varMap = result.map;
                    style.innerText = result.css;
                    Object.keys(changes).forEach(function(name){
                        if(changes[name] !== null)
                        {
                            style.currentVars[name] = changes[name];
                        }else
                        {
                            delete style.currentVars[name];
                        }
                    })
                });
            }
        }

       /* */
    }



    if(window.themes && Array.isArray(window.themes)){
        window.themes.forEach(function(theme) {
            window.installTheme(theme);
        })
    }
    delete window.themes;


    (function loadStyles(){
        const hideBodyWhileStylesAreLoading = true;
        if(isNativeSupport)
        {
            if (hideBodyWhileStylesAreLoading) {
                document.body.style.opacity = 0;
            }

            return import(/* webpackChunkName: "customization" */ "/builds/dev/applications/aehr-client/src/ds-styles.scss").then(function (foo) {
                const head = document.head || document.getElementsByTagName('head')[0];
                const style = document.createElement('style');
                style.innerText = foo.default;
                if(styleCustomization.length)
                {
                    head.insertBefore(style, styleCustomization[0])
                } else {
                    head.appendChild(style);
                }
                 if (hideBodyWhileStylesAreLoading) {
                    document.body.style.opacity = 1;
                }
            });
        } else {
            window.__dsChangeBrandingVariables = window.applyCustomization;
            document.body.style.opacity = 0;
            return import(/* webpackChunkName: "customizationIE11" */ "/builds/dev/applications/aehr-client/node_modules/@aw/ads-styles/customizationPlugin/customizationStylesIE11").then(() => {
                document.body.style.opacity = 1;
            });
        }
    })().finally(function(){
        document.dispatchEvent(new Event('customizationPlugin.stylesLoaded'));
    })

})()

